var map = {
	"./abstract01.webp": 2395,
	"./abstract010.webp": 2396,
	"./abstract02.webp": 2397,
	"./abstract03.webp": 2398,
	"./abstract05.webp": 2399,
	"./abstract06.webp": 2400,
	"./abstract07.webp": 2401,
	"./big_head_-1.webp": 2402,
	"./big_head_-10.webp": 2403,
	"./big_head_-2.webp": 2404,
	"./big_head_-3.webp": 2405,
	"./big_head_-5.webp": 2406,
	"./big_head_-6.webp": 2407,
	"./big_head_-7.webp": 2408,
	"./small_head_-1.webp": 2409,
	"./small_head_-10.webp": 2410,
	"./small_head_-2.webp": 2411,
	"./small_head_-3.webp": 2412,
	"./small_head_-5.webp": 2413,
	"./small_head_-6.webp": 2414,
	"./small_head_-7.webp": 2415,
	"./sponsor-banner-cn-m.webp": 2416,
	"./sponsor-banner-cn.webp": 2417,
	"./sponsor-banner-id-m.webp": 2418,
	"./sponsor-banner-id.webp": 2419,
	"./sponsor-banner-m.webp": 2420,
	"./sponsor-banner-ms-m.webp": 2421,
	"./sponsor-banner-ms.webp": 2422,
	"./sponsor-banner.webp": 2423,
	"./sponsor-bg-1-cn.webp": 2424,
	"./sponsor-bg-1-id.webp": 2425,
	"./sponsor-bg-1-ms.webp": 2426,
	"./sponsor-bg-1.webp": 2427,
	"./sponsor-bg-2-cn.webp": 2428,
	"./sponsor-bg-2-id.webp": 2429,
	"./sponsor-bg-2-ms.webp": 2430,
	"./sponsor-bg-2.webp": 2431,
	"./sponsor-bg-m-2-cn.webp": 2432,
	"./sponsor-bg-m-2-id.webp": 2433,
	"./sponsor-bg-m-2-ms.webp": 2434,
	"./sponsor-bg-m-2.webp": 2435,
	"./sponsor-video-one.mp4": 2436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2394;